<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">Registrar Institución</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="onBack()"
    >
      Volver
    </button>
  </div>
  <form [formGroup]="institucionForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div *ngFor="let field of fieldOrder">
        <!-- Estilo especial para el campo "clave" -->
        <ng-container *ngIf="field === 'clave'; else normalField">
          <label for="clave" class="block font-semibold mb-1">Clave</label>
          <div class="relative">
            <input
              id="clave"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="clave"
              class="border border-gray-300 rounded w-full py-2 px-4 pr-10"
              placeholder="Ingresar clave"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-0 px-3 py-2"
              (click)="togglePasswordVisibility()"
            >
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
        </ng-container>

        <!-- Estilo normal para otros campos -->
        <ng-template #normalField>
          <label [for]="field" class="block text-lg font-medium"
            >{{ formatLabel(field) }} *</label
          >
          <input
            [id]="field"
            type="text"
            [formControlName]="field"
            placeholder="Ingresar {{ formatLabel(field) }}"
            class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <small
            *ngIf="
              institucionForm.controls[field].touched &&
              institucionForm.controls[field].invalid
            "
            class="text-red-500"
          >
            Este campo es obligatorio.
          </small>
        </ng-template>
      </div>
    </div>

    <div class="flex justify-end items-center mt-6">
      <button
        type="submit"
        [disabled]="institucionForm.invalid"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Guardar
      </button>
    </div>
  </form>
</div>
